import { Box, HStack, Text } from '@chakra-ui/react';

import { IconsLinear } from '@nocowanie/icons/linear';

import { NearbyAccommodationsMessageProps } from './nearby-accommodations-message.props';

export const NearbyAccommodationsMessage = ({
    locationName,
    withDates = false,
    t,
}: NearbyAccommodationsMessageProps) => {
    const messageKey = withDates ? 'messageWithDates' : 'messageWithoutDates';

    return (
        <HStack
            p={4}
            align={'start'}
            bg={'secondary.50'}
            color={'black.950'}
            borderRadius={'tile'}
            boxShadow={'md'}
            mb={6}
        >
            <IconsLinear.InfoCircle fontSize={'2xl'} />
            <Box>
                <Text as={'h3'} fontSize={'md'} fontWeight={'semibold'} mb={2}>
                    {t?.('title')}
                </Text>
                <Text
                    fontSize={'md'}
                    lineHeight={1.5}
                    css={{
                        '& strong:first-child': {
                            color: 'brand.600',
                        },
                    }}
                    dangerouslySetInnerHTML={{
                        __html:
                            t?.(messageKey, {
                                locationName,
                            }) || '',
                    }}
                />
            </Box>
        </HStack>
    );
};
